import { Link } from 'react-router-dom';
import { categories } from '@/mocks/works';
import SectionHeading from '@/components/feature/SectionHeading';
import Reveal from '@/components/base/Reveal';

const iconMap: Record<string, string> = {
  圈内爆料: 'ri-flashlight-fill',
  深度盘点: 'ri-file-list-3-line',
  现场直击: 'ri-live-line',
  反差名场面: 'ri-contrast-2-line',
  幕后花絮: 'ri-movie-2-line',
};

export default function CategoriesSection() {
  return (
    <section className="w-full bg-primary-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="五种写法"
            title="按主题找你想看的"
            description="同一件事，不同主题对应完全不同的阅读体验。挑一个方向进去，专辑里已经按热度排好。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((cat, index) => (
            <Reveal key={cat.id} delay={index * 60}>
              <Link
                to={`/works?category=${encodeURIComponent(cat.name)}`}
                className="group flex h-full flex-col rounded-lg border border-primary-100 bg-background-50 p-5 transition-colors hover:border-primary-300"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${iconMap[cat.name] ?? 'ri-price-tag-3-line'} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{cat.name}</h3>
                <p className="mt-2 flex-1 font-body text-xs leading-relaxed text-foreground-600">{cat.desc}</p>
                <span className="mt-4 font-label text-xs text-primary-600">{cat.count} 篇作品</span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}